import { AccountingReportFilterInterface } from '@accounting/interfaces/accounting-reports';
import { BPCTableField } from '@shared/interfaces/bpc-table-interface';

export const filters: AccountingReportFilterInterface = {
  period: {
    label: 'global.accounting_reports.period.label',
    placeholder: 'global.accounting_reports.period.placeholder',
    options: [
      {
        text: 'global.accounting_reports.period.option.today',
        value: 'today',
      },
      {
        text: 'global.accounting_reports.period.option.yesterday',
        value: 'yesterday',
      },
      {
        text: 'global.accounting_reports.period.option.this_week',
        value: 'this_week',
      },
      {
        text: 'global.accounting_reports.period.option.last_week',
        value: 'last_week',
      },
      {
        text: 'global.accounting_reports.period.option.this_month',
        value: 'this_month',
      },
      {
        text: 'global.accounting_reports.period.option.last_month',
        value: 'last_month',
      },
      {
        text: 'global.accounting_reports.period.option.this_trimester',
        value: 'this_trimester',
      },
      {
        text: 'global.accounting_reports.period.option.last_trimester',
        value: 'last_trimester',
      },
      {
        text: 'global.accounting_reports.period.option.this_year',
        value: 'this_year',
      },
      {
        text: 'global.accounting_reports.period.option.last_year',
        value: 'last_year',
      },
      {
        text: 'global.accounting_reports.period.option.custom',
        value: 'custom',
      },
    ],
  },
  dateRange: {
    label: 'global.accounting_reports.date_range.label',
    placeholder: 'global.accounting_reports.date_range.placeholder',
  },
  origin: {
    label: 'global.accounting_reports.origin.label',
    placeholder: 'global.accounting_reports.origin.placeholder',
    options: [
      {
        text: 'global.accounting_reports.origin.option.pos_sales',
        value: 'pos_sales',
      },
      {
        text: 'global.accounting_reports.origin.option.online_sales',
        value: 'online_sales',
      },
    ],
  },
  productType: {
    label: 'global.accounting_reports.product_type.label',
    placeholder: 'global.accounting_reports.product_type.placeholder',
    options: [
      {
        text: 'global.accounting_reports.product_type.option.booking',
        value: 'booking',
      },
      {
        text: 'global.accounting_reports.product_type.option.subscription',
        value: 'subscription',
      },
      {
        text: 'global.accounting_reports.product_type.option.enrollment',
        value: 'enrollment',
      },
      {
        text: 'global.accounting_reports.product_type.option.attendee',
        value: 'attendee',
      },
      {
        text: 'global.accounting_reports.product_type.option.entry',
        value: 'entry',
      },
    ],
  },
};

export const accountingReportSessionTableFields: BPCTableField[] = [
  {
    key: 'code',
    headerLabel: `global.accounting_report.sessions.code.header`,
    order: 0,
  },
  {
    key: 'date',
    headerLabel: `global.accounting_report.sessions.date.header`,
    order: 0,
  },
  {
    key: 'startTime',
    headerLabel: `global.accounting_report.sessions.start_time.header`,
    order: 0,
  },
  {
    key: 'endTime',
    headerLabel: `global.accounting_report.sessions.end_time.header`,
    order: 0,
  },
  {
    key: 'origin',
    headerLabel: `global.accounting_report.sessions.origin.header`,
    order: 0,
  },
  {
    key: 'totalSales',
    headerLabel: `global.accounting_report.sessions.total_sales.header`,
    order: 0,
  },
  {
    key: 'status',
    headerLabel: `global.accounting_report.sessions.status.header`,
    order: 0,
  },
];

export const accountingReportSaleTableFields: BPCTableField[] = [
  {
    key: 'code',
    headerLabel: `global.accounting_report.sales.code.header`,
    order: 0,
  },
  {
    key: 'accountNumber',
    headerLabel: `global.accounting_report.sales.account_number.header`,
    order: 0,
  },
  {
    key: 'articleName',
    headerLabel: `global.accounting_report.sales.article_name.header`,
    order: 0,
  },
  {
    key: 'totalPrice',
    headerLabel: `global.accounting_report.sales.total_price.header`,
    order: 0,
  },
  {
    key: 'contactName',
    headerLabel: `global.accounting_report.sales.contact_name.header`,
    order: 0,
  },
  {
    key: 'date',
    headerLabel: `global.accounting_report.sales.date.header`,
    order: 0,
  },
  {
    key: 'origin',
    headerLabel: `global.accounting_report.sales.origin.header`,
    order: 0,
  },
  {
    key: 'status',
    headerLabel: `global.accounting_report.sales.status.header`,
    order: 0,
  },
];

export const accountingReportPaymentTableFields: BPCTableField[] = [
  {
    key: 'code',
    headerLabel: `global.accounting_report.payments.code.header`,
    order: 0,
  },
  {
    key: 'date',
    headerLabel: `global.accounting_report.payments.date.header`,
    order: 0,
  },
  {
    key: 'time',
    headerLabel: `global.accounting_report.payments.time.header`,
    order: 0,
  },
  {
    key: 'contactName',
    headerLabel: `global.accounting_report.payments.contact_name.header`,
    order: 0,
  },
  {
    key: 'accountNumber',
    headerLabel: `global.accounting_report.payments.account_number.header`,
    order: 0,
  },
  {
    key: 'methodType',
    headerLabel: `global.accounting_report.payments.method_type.header`,
    order: 0,
  },
  {
    key: 'invoiceCode',
    headerLabel: `global.accounting_report.payments.invoice_code.header`,
    order: 0,
  },
  {
    key: 'paidAmount',
    headerLabel: `global.accounting_report.payments.paid_amount.header`,
    order: 0,
  },
  {
    key: 'origin',
    headerLabel: `global.accounting_report.payments.origin.header`,
    order: 0,
  },
  {
    key: 'status',
    headerLabel: `global.accounting_report.payments.status.header`,
    order: 0,
  },
];

export const accountingReportDisplayFields = {
  saleStatus: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'shopping_cart', label: 'accounting.orders.status.shopping_cart.label' },
      {
        value: 'payment_process',
        label: 'accounting.orders.status.payment_process.label',
      },
      { value: 'waiting', label: 'accounting.orders.status.waiting.label' },
      { value: 'invoiced', label: 'accounting.orders.status.invoiced.label' },
      { value: 'offered', label: 'accounting.orders.status.offered.label' },
      { value: 'paid', label: 'accounting.orders.status.paid.label' },
      { value: 'cancelled', label: 'accounting.orders.status.cancelled.label' },
    ],
    valueToVariant: [
      { value: 'shopping_cart', variant: 'warning' },
      { value: 'payment_process', variant: 'warning' },
      { value: 'waiting', variant: 'info' },
      { value: 'invoiced', variant: 'success' },
      { value: 'offered', variant: 'success' },
      { value: 'paid', variant: 'success' },
      { value: 'cancelled', variant: 'danger' },
    ],
  },
  paymentStatus: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'waiting', label: 'global.status.waiting' },
      {
        value: 'ongoing',
        label: 'global.status.ongoing',
      },
      { value: 'paid', label: 'global.status.paid' },
      { value: 'cancelled', label: 'global.status.cancelled' },
      { value: 'timer_expired', label: 'global.status.timer_expired' },
    ],
    valueToVariant: [
      { value: 'timer_expired', variant: 'info' },
      { value: 'ongoing', variant: 'warning' },
      { value: 'waiting', variant: 'info' },
      { value: 'paid', variant: 'success' },
      { value: 'cancelled', variant: 'danger' },
    ],
  },
  sessionStatus: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'opened', label: 'global.fields.status.opened.label' },
      { value: 'stopped', label: 'global.fields.status.stopped.label' },
      { value: 'closed', label: 'global.fields.status.closed.label' },
    ],
    valueToVariant: [
      { value: 'opened', variant: 'success' },
      { value: 'stopped', variant: 'warning' },
      { value: 'closed', variant: 'danger' },
    ],
  },
  paymentMethodType: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'cash', label: 'global.payment.cash' },
      {
        value: 'wipay_terminal',
        label: 'global.payment.wipay_terminal',
      },
      { value: 'electronic_sport_voucher', label: 'global.payment.electronic_sport_voucher' },
      { value: 'money_transfer', label: 'global.payment.money_transfer' },
      { value: 'cheque', label: 'global.payment.cheque' },
      { value: 'sport_cheque', label: 'global.payment.sport_cheque' },
      { value: 'sodexo_cheque', label: 'global.payment.sodexo_cheque' },
      { value: 'stripe_card', label: 'global.payment.stripe' },
      { value: 'stripe_bancontact', label: 'global.payment.bancontact' },
      { value: 'cashdro', label: 'global.payment.cashdro' },
    ],
    valueToVariant: [
      { value: 'cash', variant: 'light' },
      { value: 'wipay_terminal', variant: 'light' },
      { value: 'electronic_sport_voucher', variant: 'light' },
      { value: 'money_transfer', variant: 'light' },
      { value: 'cheque', variant: 'light' },
      { value: 'sport_cheque', variant: 'light' },
      { value: 'sodexo_cheque', variant: 'light' },
      { value: 'stripe_card', variant: 'light' },
      { value: 'stripe_bancontact', variant: 'light' },
      { value: 'cashdro', variant: 'light' },
    ],
  },
  contact: {
    displayType: 'contact-link',
    useDrawer: true,
    formConfigName: 'edit',
    drawerSize: 'lg',
    configFileName: 'contact',
  },
};

export const accountingReportSessionFormFields = {
  code: {
    fieldPath: 'code',
    fieldReadPath: 'code',
    name: 'code',
    label: 'global.accounting_report.sessions.code.header',
    inputType: 'input',
    id: 'accounting_report_session__code',
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'global.accounting_report.sessions.status.header',
    inputType: 'select',
    options: [
      {
        text: 'global.fields.status.opened.label',
        value: 'opened',
      },
      {
        text: 'global.fields.status.stopped.label',
        value: 'stopped',
      },
      {
        text: 'global.fields.status.closed.label',
        value: 'closed',
      },
    ],
    id: 'accounting_report_session__status',
    valueToColor: [
      { value: 'opened', color: 'border-0 text-white bg-success' },
      { value: 'stopped', color: 'border-0 text-white bg-warning' },
      { value: 'closed', color: 'border-0 text-white bg-danger' },
    ],
  },
  origin: {
    fieldPath: 'origin',
    fieldReadPath: 'origin',
    name: 'origin',
    label: 'global.accounting_report.sessions.origin.header',
    inputType: 'select',
    options: [
      {
        text: 'global.accounting_reports.origin.option.pos_sales',
        value: 'pos_sales',
      },
      {
        text: 'global.accounting_reports.origin.option.online_sales',
        value: 'online_sales',
      },
    ],
    id: 'accounting_report_session__origin',
  },
  date: {
    fieldPath: 'date',
    fieldReadPath: 'date',
    name: 'date',
    label: 'global.accounting_report.sessions.date.header',
    inputType: 'datepicker',
    id: 'accounting_report_session__date',
  },
  startTime: {
    fieldPath: 'startTime',
    fieldReadPath: 'startTime',
    name: 'startTime',
    label: 'global.accounting_report.sessions.start_time.header',
    id: 'accounting_report_session__start_time',
  },
  endTime: {
    fieldPath: 'endTime',
    fieldReadPath: 'endTime',
    name: 'endTime',
    label: 'global.accounting_report.sessions.end_time.header',
    id: 'accounting_report_session__end_time',
  },
  totalSales: {
    fieldPath: 'totalSales',
    fieldReadPath: 'totalSales',
    name: 'totalSales',
    label: 'global.accounting_report.sessions.total_sales.header',
    options: [],
    id: 'global__total_sales',
    appendIcon: 'euro-sign',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
  },
  bundledPayments: {
    fieldPath: 'bundledPayments',
    fieldReadPath: 'bundledPayments',
    name: 'bundledPayments',
    label: 'global.accounting_report.sessions.bundled_payments.label',
    id: 'accounting_report_session__bundled_payments',
  },
  bundledSales: {
    fieldPath: 'bundledSales',
    fieldReadPath: 'bundledSales',
    name: 'bundledSales',
    label: 'global.accounting_report.sessions.bundled_sales.label',
    id: 'accounting_report_session__bundled_sales',
  },
};
